import { Card } from '@aws-amplify/ui-react';
import { FC } from 'react';
import { AddressBook, DeviceAddressBooks } from '@/types/address-book';
import { AddressBookBlock } from './address-book-block';

const MAX_LISTED_DEVICES = 5;

export type AddressBookSummaryProps = {
  addressBook: AddressBook;
  devices: DeviceAddressBooks[];
  organisationId: number;
  unitId: number;
  editEnabled: boolean;
};

/**
 * Consolidated view of a single address book shared across devices. Shows the
 * book once and lists the devices using it, clamped to the first few with a
 * total count, so a healthy unit isn't a wall of identical cards.
 */
export const AddressBookSummary: FC<AddressBookSummaryProps> = ({
  addressBook,
  devices,
  organisationId,
  unitId,
  editEnabled,
}) => {
  const shown = devices.slice(0, MAX_LISTED_DEVICES);
  const remaining = devices.length - shown.length;

  return (
    <Card className="flex flex-col gap-4">
      <AddressBookBlock
        addressBook={addressBook}
        editEnabled={editEnabled}
        organisationId={organisationId}
        unitId={unitId}
      >
        <div className="flex flex-col gap-1">
          <span className="text-sm font-medium">
            Used by {devices.length} device{devices.length === 1 ? '' : 's'}
          </span>
          <ul className="flex flex-col gap-0.5 text-sm text-gray-600">
            {shown.map((device) => (
              <li key={device.deviceId}>{device.displayName}</li>
            ))}
            {remaining > 0 && (
              <li className="text-gray-500 italic">and {remaining} more</li>
            )}
          </ul>
        </div>
      </AddressBookBlock>
    </Card>
  );
};
